export default (context, params) => {
    context.overlay = params.overlay
    context.popup.text = params.text
    context.popup.moreText = params.moreText
    context.popup.growButton = params.growButton
    context.popup.value = params.value
}